import React from 'react'

const ServiceIconTwo = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <g clipPath="url(#clip0_568_135)">
                <path d="M17.922 36.0134L17.391 35.7779C16.8 35.5184 3 29.2859 3 17.9999V8.21393C3.00053 7.27218 3.29818 6.35461 3.85056 5.59189C4.40294 4.82916 5.1819 4.26016 6.0765 3.96593L18 0.0134277L29.9235 3.96593C30.8181 4.26016 31.5971 4.82916 32.1494 5.59189C32.7018 6.35461 32.9995 7.27218 33 8.21393V17.9999C33 30.8654 19.068 35.6324 18.474 35.8304L17.922 36.0134ZM18 3.15893L7.026 6.79793C6.72742 6.89545 6.46735 7.08496 6.28306 7.33932C6.09876 7.59367 5.99968 7.89982 6 8.21393V17.9999C6 26.2409 15.66 31.5869 18.0705 32.7914C20.4765 31.8239 30 27.3944 30 17.9999V8.21393C30.0003 7.89982 29.9012 7.59367 29.7169 7.33932C29.5326 7.08496 29.2726 6.89545 28.974 6.79793L18 3.15893Z" fill="#0C0B0B" />
                <path d="M16.6666 21.813H16.6171C16.2375 21.8072 15.8629 21.7244 15.5162 21.5698C15.1694 21.4151 14.8576 21.1916 14.5996 20.913L11.1406 17.313L13.3021 15.24L16.6681 18.75L24.4396 10.9785L26.5606 13.0995L18.6691 20.991C18.4063 21.2536 18.094 21.4615 17.7502 21.6026C17.4065 21.7437 17.0382 21.8152 16.6666 21.813Z" fill="#0C0B0B" />
            </g>
            <defs>
                <clipPath id="clip0_568_135">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default ServiceIconTwo